import React from 'react';
import { Link } from 'react-router-dom';
import partsImg from '../../assets/city-hardware-detroit-parts.png';
import toolsImg from '../../assets/city-hardware-detroit-tools.png';
import interiorImg from '../../assets/cityhardwaredetroit.png';
import aisle001Img from '../../assets/city-hardware-detroit-001.png';
import './CategoryGrid.css';

// Map category names to real photos where we have them, fall back to dark color
const CATEGORIES = [
  { name: 'Power Tools',      count: '120+ items', img: toolsImg },
  { name: 'Hand Tools',       count: '80+ items',  img: toolsImg,    tint: 'rgba(0,0,0,0.45)' },
  { name: 'Fasteners',        count: '200+ items', img: partsImg },
  { name: 'Paint & Supplies', count: '90+ items',  img: aisle001Img, tint: 'rgba(0,0,0,0.5)'  },
  { name: 'Plumbing',         count: '60+ items',  img: interiorImg, tint: 'rgba(0,0,0,0.55)' },
  { name: 'Lawn & Garden',    count: '70+ items',  img: aisle001Img, tint: 'rgba(0,0,0,0.45)' },
  { name: 'Electrical',       count: '50+ items',  img: partsImg,    tint: 'rgba(0,0,0,0.5)'  },
  { name: 'Storage',          count: '40+ items',  img: interiorImg, tint: 'rgba(0,0,0,0.48)' },
];

function CategoryGrid() {
  return (
    <section className="category-grid">
      <div className="container">
        <div className="category-grid__header">
          <h2 className="category-grid__heading">Shop By Category</h2>
          <Link to="/services" className="category-grid__see-all">View All →</Link>
        </div>
        <div className="category-grid__grid">
          {CATEGORIES.map((cat) => (
            <Link
              key={cat.name}
              to="/services"
              className="cat-card"
            >
              {/* Real photo background */}
              <img
                src={cat.img}
                alt={cat.name}
                className="cat-card__bg"
              />
              {/* Dark overlay */}
              <div
                className="cat-card__overlay"
                style={{ background: cat.tint || 'rgba(0,0,0,0.42)' }}
              />
              <div className="cat-card__inner">
                <span className="cat-card__name">{cat.name}</span>
                <span className="cat-card__count">{cat.count}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CategoryGrid;
